import React, { useState } from 'react';
import styled from 'styled-components';
import { colors } from 'styleguide';

import { PlusCircle } from 'craft/icons';

const Form = styled.form`
  border: 1px dashed ${colors('tertiary', 3)};
  border-radius: 2px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;
`;

const Input = styled.input`
  font-weight: 600;
  color: ${colors('tertiary', -1)};
  appearance: none;
  border: none;
  outline: none;
  width: 100%;
  margin-left: 16px;
`;

interface Props {
  onCreate: (title: string) => void;
}

export const NewItemInput = ({ onCreate }: Props) => {
  const [text, setText] = useState('');
  return (
    <Form
      onSubmit={(e: any) => {
        e.preventDefault();
        if (text) {
          onCreate(text);
          setText('');
        }
      }}
    >
      <PlusCircle />
      <Input
        type="text"
        placeholder="Write new step and press enter"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setText(e.target.value)}
        value={text}
        data-craft-ignore-events
      />
    </Form>
  );
};
